import React from 'react'
import { useTranslation } from 'react-i18next'
import { SECTION } from 'utils/section'
import styles from './Slogan.module.scss'

export const Slogan = () => {
  const { t } = useTranslation()
  return (
    <section id={SECTION.SLOGAN} className={styles['section']}>
      <div className={styles['container']}>
        <h3>
          <span className={styles['text1']}>{t('slogan.text1')}</span> <span className={styles['text2']}>{t('slogan.text2')}</span>
        </h3>
      </div>
    </section>
  )
}
